var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Tooltip
 */

var Tooltip = function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  function Tooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      left: 'auto',
      visible: _this.props.visible
    }, _this.show = function () {
      _this.setState({
        visible: true
      });
    }, _this.hide = function () {
      _this.setState({
        visible: false
      });
    }, _this.tooltipRef = null, _temp), _possibleConstructorReturn(_this, _ret);
  }
  /**
   * Property types
   */


  /**
   * Default properties
   */


  /**
   * Initial state
   */


  _createClass(Tooltip, [{
    key: 'componentDidMount',


    /**
     * Get width of tooltip
     */
    value: function componentDidMount() {
      // to get the right width we have to make sure
      // that the tooltip is scaled properly
      // invisible tooltips are scaled down to 0
      // and there we aren't able to get the right width

      // when initially hidden we do not have any refs
      if (!this.tooltipRef) {
        return;
      }
      var tooltipRect = this.tooltipRef.getBoundingClientRect();
      var contentRect = this.refs.content.getBoundingClientRect();
      var left = contentRect.width / 2 + contentRect.left - tooltipRect.width / 2;
      this.setState({ left: left });
    }

    /**
     * Placeholder for tooltip ref
     * first-class references
     * https://github.com/reactjs/react-future/blob/master/01%20-%20Core/06%20-%20Refs.js
     * https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute
     */

  }, {
    key: 'render',


    /**
     * Render component
     */
    value: function render() {
      var _this2 = this;

      var left = this.state.left;

      return React.createElement(
        'div',
        { onMouseOver: this.show, onMouseOut: this.hide },
        React.Children.map(this.props.children, function (child) {
          return React.cloneElement(child, {
            ref: 'content'
          });
        }),
        React.createElement(
          'div',
          {
            className: classnames('Tooltip', {
              'is-active': this.state.visible
            }),
            ref: function ref(component) {
              _this2.tooltipRef = component;
            },
            style: { left: left }
          },
          this.props.content
        )
      );
    }
  }]);

  return Tooltip;
}(React.Component);

Tooltip.propTypes = {
  content: PropTypes.string,
  visible: PropTypes.bool };
Tooltip.defaultProps = {
  content: 'tooltip content',
  visible: false };
export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ../es/js/tooltip/index.js
// module id = 315
// module chunks = 0